import { defineChain } from 'viem';
import { CHAINS } from './chains';

// Helper function to create wagmi chain definition from CHAINS config
const createWagmiChain = (chainKey) => {
  const chain = CHAINS[chainKey];
  if (!chain || !chain.active || chain.chainIdDecimal === 0) {
    return null; // Skip inactive chains or chains without EVM chainId (like Solana, Noble)
  }
  
  return defineChain({
    id: chain.chainIdDecimal,
    name: chain.name,
    nativeCurrency: {
      name: chain.nativeCurrency.name,
      symbol: chain.nativeCurrency.symbol,
      decimals: chain.nativeCurrency.decimals,
    },
    rpcUrls: {
      default: {
        http: [chain.rpcUrl],
      },
    },
    blockExplorers: {
      default: {
        name: `${chain.name} Explorer`,
        url: chain.blockExplorerUrl,
      },
    },
    testnet: chain.network !== 'mainnet',
  });
};

// Define all active chains for wagmi.
// Mainnet siblings (`*_mainnet`) are distinct from Sepolia/testnet keys —
// never interchange them (same pattern as arbitrum vs arbitrum_mainnet,
// bnb vs bnb_mainnet).
export const arbitrumMainnet = createWagmiChain('arbitrum_mainnet');
export const arbitrumSepolia = createWagmiChain('arbitrum');
export const ethereumMainnet = createWagmiChain('ethereum_mainnet');
export const ethereumSepolia = createWagmiChain('ethereum');
export const baseMainnet = createWagmiChain('base_mainnet');
export const baseSepolia = createWagmiChain('base');
export const arcTestnet = createWagmiChain('arc');
export const stableTestnet = createWagmiChain('stable');
export const bnbMainnet = createWagmiChain('bnb_mainnet');
export const bnbTestnet = createWagmiChain('bnb');
export const tempoTestnet = createWagmiChain('tempo');
export const robinhoodMainnet = createWagmiChain('robinhood_mainnet');

// Export all chains that should be supported by Privy + Wagmi
// Include all active chains (filter out null values for inactive chains)
export const supportedWagmiChains = [
  arbitrumMainnet,
  arbitrumSepolia,
  ethereumMainnet,
  ethereumSepolia,
  baseMainnet,
  baseSepolia,
  arcTestnet,
  stableTestnet,
  bnbMainnet,
  bnbTestnet,
  tempoTestnet,
  robinhoodMainnet,
].filter(Boolean); // Remove any null values
